import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setIsSuggestionsDropdownVisible } from '../actions/publicActions';

mutator(setIsSuggestionsDropdownVisible, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible =
        actionMessage.isSuggestionsDropdownVisible;
});
